import { AnalysisObjectInput } from './analysis-object-input';
import { AnalysisPathInput } from './analysis-path-input';
import { AnalysisBoolInput } from './analysis-bool-input';
import { AnalysisSelectInput } from './analysis-select-input';
import { AnalysisStringInput } from './analysis-string-input';
import { AnalysisInputProps } from '../types';
import { AnalysisListInput } from './analysis-list-input';

export function AnalysisInputSwitch(props: AnalysisInputProps) {
  const { value, ...sharedProps } = props;
  switch (props.value._type) {
    case 'object':
      return <AnalysisObjectInput value={props.value} {...sharedProps} />;
    case 'path':
      return <AnalysisPathInput value={props.value} {...sharedProps} />;
    case 'boolean':
      return <AnalysisBoolInput value={props.value} {...sharedProps} />;
    case 'selection':
      return <AnalysisSelectInput value={props.value} {...sharedProps} />;
    case 'string':
      return <AnalysisStringInput value={props.value} {...sharedProps} />;
    case 'list':
      return <AnalysisListInput value={props.value} {...sharedProps} />;
    default:
      return <div>Type: {props.value}</div>;
  }
}
